<template>
  <!-- Error page-->
  <div class="misc-wrapper">
    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <img :src="logoUrl" alt="logo" height="50" />
      </div>
      <div class="w-100 text-center">
        <b-img fluid :src="imgUrl" class="mb-3" alt="Error page" />

        <h2 class="mb-1">
          Page Not Found
        </h2>
        <p class="mb-2">
          Oops! 😖 The requested URL was not found on this server.
        </p>

        <b-button variant="primary" class="mb-2 btn-sm-block" :to="{ path: '/vaults' }">
          Return Home
        </b-button>
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BButton, BImg } from 'bootstrap-vue'
import store from '@/store/index'

export default {
  components: {
    BButton,
    BImg
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error-v2.png')
    }
  },
  computed: {
    logoUrl() {
      return require('@/assets/images/logo/mobile-text-logo.svg')
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-v2.png')
        return this.downImg
      }
      return this.downImg
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
